export const modes = [
  {
    name: 'draw',
    key:'d',
    iconname: 'pencil',
    active:true
  },
  {
    name: 'select',
    key:'s',
    iconname: 'hand pointer',
    active:false
  },
  {
    name: 'grid',
    key:'g',
    iconname: 'grid layout',
    active:false
  },
  {
    name: 'inspect',
    key:'p',
    iconname: 'list',
    active:false
  },
];
